import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppInjectorService } from '@app/core/services/app-injector.service';
import { PortalTranslateService } from '@app/translate/services/portal-translate.service';
import { TranslateService } from '@ngx-translate/core';

/**
 * Translate the given key with an optional prefix and optional interpolate parameters
 * @param prefix The prefix to use when translating
 */
export function translateInstant(prefix: string) {
  return function (key: string) {
    const prefixedKey = prefix + key;
    const translated: string = AppInjectorService.injector.get(TranslateService).instant(prefixedKey);

    return prefixedKey === translated ? key : translated;
  };
}

/**
 * Returns a signal that contains the current language.
 * Can only be created in an injection context.
 */
export function currentLanguage(): Signal<string> {
  const translateService = inject(PortalTranslateService);

  return toSignal(translateService.activeLanguage$);
}
